import { Skeleton, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';

type Props = {
  amount: number;
};

export const ChartLegend = ({ amount }: Props) => {
  return (
    <TableContainer sx={{ height: '100%' }}>
      <Table
        role="presentation"
        size="small"
        stickyHeader
        sx={{
          tableLayout: 'fixed',
          width: '100%',
          tbody: {
            td: { '&:nth-of-type(2), &:nth-of-type(3)': { width: '3rem' } },
            'td, th': { border: 0 },
          },
          'td, th': { px: 0.75, py: 0.625, lineHeight: '1' },
        }}
      >
        <TableBody>
          {Array(amount)
            .fill('')
            .map((_, idx: number) => (
              <TableRow key={idx}>
                <TableCell component="th" scope="row">
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Skeleton
                      variant="rounded"
                      width={12}
                      height={12}
                      sx={{
                        mr: 1,
                        ml: 0.5,
                      }}
                    />
                    <Skeleton variant="rounded" width={85} height={16} sx={{ my: 0.25 }} />
                  </div>
                </TableCell>
                <TableCell align="right">
                  <Skeleton variant="rounded" width={30} height={20} sx={{ display: 'inline-block' }} />
                </TableCell>
                <TableCell align="right">
                  <Skeleton variant="rounded" width={20} height={20} sx={{ display: 'inline-block' }} />
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
